import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#eeece9] pt-20 pb-8">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 pb-16 border-b border-[#c9a84c]/20">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <span className="text-[#c9a84c] text-2xl font-semibold tracking-widest" style={{ fontFamily: "'Cormorant Garamond', serif", letterSpacing: '0.15em' }}>필그린</span>
            </div>
            <p className="text-[#6b5e4e] text-sm leading-relaxed">
              서울 강남에서 책임 시공으로<br />
              신뢰받는 인테리어 전문 업체입니다.
            </p>
            <div className="flex items-center gap-4 mt-6">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#c9a84c]/30 text-[#6b5e4e] hover:border-[#c9a84c] hover:text-[#c9a84c] transition-colors cursor-pointer">
                <i className="ri-instagram-line text-sm" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#c9a84c]/30 text-[#6b5e4e] hover:border-[#c9a84c] hover:text-[#c9a84c] transition-colors cursor-pointer">
                <i className="ri-youtube-line text-sm" />
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-[#c9a84c]/30 text-[#6b5e4e] hover:border-[#c9a84c] hover:text-[#c9a84c] transition-colors cursor-pointer">
                <i className="ri-kakao-talk-line text-sm" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-[#3a3228] font-semibold mb-6 text-sm tracking-widest uppercase">바로가기</h4>
            <ul className="space-y-3">
              {[
                { label: '홈', path: '/' },
                { label: '서비스', path: '/services' },
                { label: '포트폴리오', path: '/portfolio' },
                { label: '견적 안내', path: '/estimate' },
                { label: '상담 신청', path: '/consultation' },
                { label: '연락처', path: '/contact' },
              ].map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-[#6b5e4e] text-sm hover:text-[#c9a84c] transition-colors cursor-pointer">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-[#3a3228] font-semibold mb-6 text-sm tracking-widest uppercase">시공 분야</h4>
            <ul className="space-y-3">
              {['아파트 인테리어', '빌라 인테리어', '오피스텔 인테리어', '상업공간 인테리어', '사무실 인테리어', '카페 & 레스토랑'].map((s) => (
                <li key={s}>
                  <span className="text-[#6b5e4e] text-sm">{s}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-[#3a3228] font-semibold mb-6 text-sm tracking-widest uppercase">기업 정보</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-building-line text-[#c9a84c] text-sm" />
                </div>
                <div>
                  <div className="text-[#9e8e7e] text-xs mb-0.5">대표자</div>
                  <span className="text-[#3a3228] text-sm">장인규</span>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-file-list-line text-[#c9a84c] text-sm" />
                </div>
                <div>
                  <div className="text-[#9e8e7e] text-xs mb-0.5">사업자등록번호</div>
                  <span className="text-[#3a3228] text-sm">213-10-24418</span>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-map-pin-line text-[#c9a84c] text-sm" />
                </div>
                <div>
                  <div className="text-[#9e8e7e] text-xs mb-0.5">주소</div>
                  <span className="text-[#3a3228] text-sm leading-relaxed">서울특별시 강남구<br />양재대로55길6 (종합상가 203호)</span>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-phone-line text-[#c9a84c] text-sm" />
                </div>
                <div>
                  <div className="text-[#9e8e7e] text-xs mb-0.5">연락처</div>
                  <span className="text-[#3a3228] text-sm">010-5350-7926</span>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-bank-line text-[#c9a84c] text-sm" />
                </div>
                <div>
                  <div className="text-[#9e8e7e] text-xs mb-0.5">계좌번호</div>
                  <span className="text-[#3a3228] text-sm">농협 301-0231-3153-81</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="flex flex-col sm:flex-row items-center justify-between pt-8 gap-4">
          <p className="text-[#9e8e7e] text-xs">© 2024 필그린. All rights reserved.</p>
          <p className="text-[#9e8e7e] text-xs">사업자등록번호: 213-10-24418 | 대표: 장인규</p>
        </div>
      </div>
    </footer>
  );
}
